import React from 'react'
import { Box, Typography } from '@mui/material'


export default function providersColumn() {

	return {
		name: 'providersNames',
		label: 'Providers',
		options: {
			setCellProps: () => ({
				sx: { maxWidth: 100 }
			}),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "start"
				}}>
				<Typography>{value?.join(', ') || "Any"}</Typography>
			</Box>,
		}
	}
}
